export default "__VITE_ASSET__BNEVzEeX__"